import { useEffect } from "react";
import { useTheme } from "../context/ThemeContext"; // 🔥 ThemeContext import

const DeleteInvoiceModal = ({ isOpen, onClose, onConfirm, order }) => {
  const { darkMode } = useTheme(); // 🔥 Dark mode állapot lekérése

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  if (!isOpen || !order) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose(); // 🔥 Ha a háttérre kattintanak, zárjuk be a modált
        }
      }}
    >
      <div
        className={`p-6 rounded-lg shadow-lg w-96 ${
          darkMode ? "bg-gray-900 text-white" : "bg-white text-gray-900"
        }`}
        onClick={(e) => e.stopPropagation()} // 🔥 Megakadályozzuk, hogy a kattintás átjusson a modalra
      >
        <h2 className={`text-xl text-center font-semibold mb-4 ${
          darkMode ? "text-red-400" : "text-red-600"
        }`}>
          Sigur doriți să ștergeți factura?
        </h2>
        <p className="mb-4 text-center">
          Factura asociată comenzii <span className="font-semibold">{order.orderNumber}</span> va fi ștearsă definitiv.
        </p>
        <div className="flex justify-between w-full">
          <button
            onClick={onClose}
            className={`px-4 py-2 rounded-lg transition ${
              darkMode
                ? "bg-gray-700 hover:bg-gray-600 text-white"
                : "bg-gray-300 hover:bg-gray-400 text-black"
            }`}
          >
            Anulează
          </button>
          <button
            onClick={() => onConfirm(order.id)}
            className={`px-4 py-2 rounded-lg transition ${
              darkMode
                ? "bg-red-700 hover:bg-red-600 text-white"
                : "bg-red-600 hover:bg-red-500 text-white"
            }`}
          >
            Șterge
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteInvoiceModal;
